import { countryMapToShortened } from 'shared/core/constants/geography';

const isPresent = (value) => value !== null && value !== undefined && value !== '';

const compact = (value) =>
  Object.fromEntries(
    Object.entries(value).filter(([, item]) => {
      if (!isPresent(item)) {
        return false;
      }

      return !Array.isArray(item) || item.length > 0;
    })
  );

const buildProductJsonLd = (productData, storeFrontAbsoluteUrl) => {
  const {
    id,
    sku,
    SKU,
    cName,
    name,
    Image,
    description,
    brand,
    recPrices,
    location,
    seller,
    type,
    subcategory,
    Status,
    isBelowThreshold,
    avgRating,
    reviewCount,
  } = productData;
  let { price } = productData;

  const productUrl = storeFrontAbsoluteUrl && cName ? `${storeFrontAbsoluteUrl}/product/${cName}` : undefined;

  if (!isPresent(price) && recPrices?.length) {
    [price] = recPrices;
  }

  const countryCode = countryMapToShortened[location?.country] || location?.country;
  const priceCurrency = countryCode === 'CA' ? 'CAD' : 'USD';
  const isOutOfStock = isBelowThreshold || (Status && Status.toLowerCase() !== 'active');
  const category = [type, subcategory].filter(Boolean).join(' > ');

  const offer = isPresent(price)
    ? compact({
        '@type': `Offer`,
        '@id': productUrl ? `${productUrl}#offer` : undefined,
        availability: `https://schema.org/${isOutOfStock ? 'OutOfStock' : 'InStock'}`,
        itemCondition: 'https://schema.org/NewCondition',
        price,
        priceCurrency,
        url: productUrl,
        seller: seller?.name
          ? compact({
              '@type': `Organization`,
              name: seller.name,
              telephone: seller.phone,
            })
          : undefined,
        availableAtOrFrom: location
          ? {
              '@type': `Place`,
              name: seller?.name,
              address: compact({
                '@type': `PostalAddress`,
                streetAddress: [location.ln1, location.ln2].filter(Boolean).join(' '),
                addressLocality: location.city,
                addressRegion: location.state,
                postalCode: location.zipcode,
                addressCountry: countryCode,
              }),
            }
          : undefined,
      })
    : undefined;

  return compact({
    '@context': `https://schema.org`,
    '@type': `Product`,
    '@id': productUrl ? `${productUrl}#product` : undefined,
    name,
    description,
    image: Array.isArray(Image) ? Image.filter(Boolean) : Image,
    url: productUrl,
    sku: sku || SKU || id,
    category,
    brand: brand?.name
      ? compact({
          '@type': `Brand`,
          name: brand.name,
          description: brand.description,
          logo: brand.imageUrl,
        })
      : undefined,
    aggregateRating:
      Number.isFinite(avgRating) && avgRating > 0 && Number.isInteger(reviewCount) && reviewCount > 0
        ? {
            '@type': `AggregateRating`,
            ratingValue: avgRating,
            reviewCount,
            bestRating: 5,
            worstRating: 1,
          }
        : undefined,
    offers: offer,
  });
};

export default buildProductJsonLd;
